import * as m from "@qpr/client-api-base/api/model";
import memoizee from "memoizee";

export const getPeriods = memoizee((id: string) => m.getPeriods(id), {
  //promise: true,
});
